module.exports = __webpack_public_path__ + "img/members.345cc635.svg";